import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT } from 'Components/reduxType/login/index';
import { loginApi } from 'Components/login/service/service';
import { createToken, logout, setUser } from 'Components/_helpers/localstorage';

/**
 * @description Iniciar sesion
 * @param {*} email 
 * @param {*} password 
 * @returns 
 */
export const loginAction = (email, password) => (dispatch) => {
  return new Promise(function(resolve, reject) {
    dispatch(request({ payload: email }));
    return loginApi(email, password).then((res) => {
      createToken(res.token);
      setUser(res);
      dispatch(success(res));
      resolve(res);
    }).catch((err) => {
      if(err.response) {
        dispatch(failure(err.response.data.message));
      } else {
        dispatch(failure('Ocurrio un problema con la aplicación. intente mas tarde.'));
      }
      reject(err)
    });
  })
  function request(user) { return { type: LOGIN_REQUEST, payload: user } }
  function success(user) { return { type: LOGIN_SUCCESS, payload: user } }
  function failure(error) { return { type: LOGIN_FAILURE, payload: error } }

}


/**
 * @description Cerrar sesion
 * @returns 
 */
export const logoutAction = () => {
  return async(dispatch) => {
    logout();
    dispatch({type: LOGOUT});
  }
}